import React, { useState, useEffect } from "react";
import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import axios from "axios";
import { Link } from "react-router-dom";
// config
import configData from "../../../config/config.json";
// components
import MetaTagsBusinessOwners from "../../../components/meta-tags-seo/MetaTagsBusinessOwners";
import Sidbarbusiness from "../../../components/business-dashboard/sidbar/Sidbarbusiness";
import HeaderMobile from "../../../components/business-dashboard/sidbar/HeaderMobile";
// img
import close from "../../../images/end user/close.png";

const BusinessExit = (props) => {
  const [render, setRender] = useState(false);

  const submitHandler = () => {
    eraseCookie("OwnerId");
    eraseCookie("BizId");
    eraseCookie("BizUuid");
    eraseCookie("token");
    eraseCookie("OwnerBizNumber");
  };

  function eraseCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
    document.cookie =
      name +
      "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=en-biz.gishniz.com; path=/";
  }

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "business-exit",
  };

  useEffect(() => {
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else if (render) {
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  }, [render]);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  let windowWidth = "00";
  if (typeof window !== "undefined") {
    // Code that relies on the window object
    windowWidth = window.innerWidth;
  } else {
    windowWidth = "00";
  }

  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      {windowWidth < 768 ? <HeaderMobile setRender={setRender} /> : ""}
      <div className="margin-0 d-flex bg_business_grey">
        <div className="  d-none d-md-block">
          {windowWidth > 767 ? <Sidbarbusiness setRender={setRender} /> : ""}
        </div>
        <MDBContainer className="bg_business_grey">
          <MDBRow>
            <MDBCol size="12">
              <div>
                <p className="text_img_bus">خروج</p>
              </div>
              <div className="container_tablighat_bus_content d-flex">
                <div className={"main_div_logout_bus"}>
                  <Link to="/business-dashboard">
                    <img
                      src={close}
                      alt="close"
                      className="close_logout_bus float-start"
                    />
                  </Link>
                  <p className={"mt28"}>
                    مطمئنید که می‌خواهید از حساب کاربری خارج شوید؟
                  </p>
                  <div className={"text-last-center pt-1"}>
                    <Link className="balebutton" to="/" onClick={submitHandler}>
                      بله
                    </Link>
                  </div>
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    </>
  );
};

export default BusinessExit;
